import is from '../_helpers/is.js';
import set from '../set.js';
import assign from '../_helpers/assign.js';
// returns a function which called when bound node state is changed (eg DOM event is fired)
export default function createNodeHandler(_ref) {
  var object = _ref.object,
    key = _ref.key,
    node = _ref.node,
    propDef = _ref.propDef,
    binder = _ref.binder,
    bindingOptions = _ref.bindingOptions;
  var _nodeHandler = function nodeHandler(domEvent) {
    if (domEvent === void 0) {
      domEvent = {};
    }
    // nodeHandler.disabled = true is set in unbindNode
    // we cannot "turn off" binder.on when its value is a function
    // developer needs to clean memory ("turn off" callback) manualy in binder.destroy
    if (_nodeHandler.disabled) {
      return;
    }
    var previousValue = propDef.value;
    var _domEvent = domEvent,
      which = _domEvent.which,
      target = _domEvent.target,
      ctrlKey = _domEvent.ctrlKey,
      altKey = _domEvent.altKey;
    var getValue = binder.getValue;
    // the handler is made only for a binder with getValue
    var value = getValue.call(node, assign({
      previousValue: previousValue,
      domEvent: domEvent,
      originalEvent: domEvent.originalEvent || domEvent,
      // jQuery thing
      // will throw "preventDefault is not a function" when domEvent is empty object
      preventDefault: function preventDefault() {
        return domEvent.preventDefault();
      },
      // will throw "stopPropagation is not a function" when domEvent is empty object
      stopPropagation: function stopPropagation() {
        return domEvent.stopPropagation();
      },
      which: which,
      target: target,
      ctrlKey: ctrlKey,
      altKey: altKey
    }, bindingOptions));
    if (!is(value, previousValue)) {
      set(object, key, value, {
        fromNode: true,
        // the following properties are needed to avoid circular changes
        // they are used at objectHandler
        changedNode: node,
        onChangeValue: value,
        binder: binder
      });
    }
  };
  return _nodeHandler;
}